module.exports = __webpack_public_path__ + "static/img/00072E_1_2_3_C_20210131_LC.fea08c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00072E_1_2_3_C_20210131_LC.png
// module id = Hs2s
// module chunks = 0